module.exports = __webpack_public_path__ + "media/images/illustrations/lock_closed_small-1496efcdf9efd193739ad79a55451de9.svg";